(function () {
  if (window.StevesProductReviewsLoaded) {
    return;
  }

  window.StevesProductReviewsLoaded = true;

  const dataCache = new Map();
  const initialVisibleReviews = 4;
  const moreReviewsStep = 4;
  const normalStarFill = '#d7d7d7';
  const ratedStarFill = '#dc0b0b';

  const defaults = {
    loading: 'Loading reviews...',
    empty: 'No reviews yet. Be the first to review this product.',
    no_reviews_short: 'No reviews yet',
    review_label: 'review',
    reviews_label: 'reviews',
    stars_suffix: 'out of 5 stars',
    average_rating: 'Average customer rating',
    recommended: 'recommended',
    write_a_review: 'Write a review',
    load_more: 'Load more reviews',
    verified_purchase: 'Verified purchase',
    location: 'Location',
    yes_recommendation: 'Yes, I recommend this product.',
    no_recommendation: 'No, I do not recommend this product.',
    submitting: 'Submitting...',
    success: 'Thank you. Your review was submitted and will appear after moderation.',
    generic_error: 'Something went wrong. Please try again.',
    validation_error: 'Please check the highlighted fields.'
  };

  function readJsonScript(root, selector, fallback) {
    const script = root.querySelector(selector);

    if (!script) {
      return fallback;
    }

    try {
      return JSON.parse(script.textContent || '');
    } catch (error) {
      return fallback;
    }
  }

  function getI18n(root) {
    return Object.assign({}, defaults, readJsonScript(root, '[data-product-review-i18n]', {}));
  }

  function normalizeSku(sku) {
    return String(sku || '').trim().toLowerCase();
  }

  function clampRating(rating) {
    const value = Number(rating) || 0;
    return Math.max(0, Math.min(5, value));
  }

  function formatRating(rating) {
    const value = clampRating(rating);
    return value % 1 === 0 ? String(value) : value.toFixed(1);
  }

  function countText(count, i18n) {
    const value = Number(count) || 0;

    if (value <= 0) {
      return i18n.no_reviews_short;
    }

    return `${value} ${value === 1 ? i18n.review_label : i18n.reviews_label}`;
  }

  function setText(element, value) {
    if (element) {
      element.textContent = value == null ? '' : String(value);
    }
  }

  function setHidden(element, isHidden) {
    if (element) {
      element.hidden = Boolean(isHidden);
    }
  }

  function createElement(tag, className, text) {
    const element = document.createElement(tag);

    if (className) {
      element.className = className;
    }

    if (text != null) {
      element.textContent = text;
    }

    return element;
  }

  function renderFallbackStars(element, rating) {
    const value = clampRating(rating);
    const filledStars = Math.round(value);
    element.replaceChildren();

    for (let index = 1; index <= 5; index++) {
      const star = createElement('span', 'product-review-stars__star', '\u2605');
      star.setAttribute('aria-hidden', 'true');

      if (index <= filledStars) {
        star.classList.add('is-filled');
      }

      element.append(star);
    }
  }

  function renderStars(element, rating, i18n) {
    if (!element) {
      return;
    }

    const value = clampRating(rating);
    element.classList.add('product-review-stars');
    element.setAttribute('role', 'img');
    element.setAttribute('aria-label', `${formatRating(value)} ${i18n.stars_suffix}`);

    if (window.jQuery && window.jQuery.fn && typeof window.jQuery.fn.rateYo === 'function') {
      const $element = window.jQuery(element);
      element.classList.add('product-review-stars--rateyo');

      try {
        $element.rateYo('option', 'rating', value);
        return;
      } catch (error) {
        // A duplicate jQuery load can drop RateYo's instance registry; reinitialize below.
      }

      $element.rateYo({
        normalFill: normalStarFill,
        ratedFill: ratedStarFill,
        halfStar: true,
        readOnly: true,
        spacing: '2px',
        starWidth: '18px',
        rating: value
      });
      return;
    }

    renderFallbackStars(element, value);
  }

  function initializeRatingPicker(element, input) {
    if (!element || !input || !window.jQuery || !window.jQuery.fn || typeof window.jQuery.fn.rateYo !== 'function') {
      return;
    }

    const $element = window.jQuery(element);
    const rating = clampRating(input.value);
    const updateInput = (value) => {
      const nextValue = Math.round(clampRating(value));
      input.value = nextValue > 0 ? String(nextValue) : '';
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };

    try {
      $element.rateYo('option', 'rating', rating);
      return;
    } catch (error) {
      // Initialize below when no RateYo instance exists for this element.
    }

    $element.rateYo({
      normalFill: normalStarFill,
      ratedFill: ratedStarFill,
      fullStar: true,
      rating,
      spacing: '4px',
      starWidth: '28px',
      onSet: updateInput
    });
  }

  function resetRatingPicker(element, input) {
    if (input) {
      input.value = '';
    }

    if (!element || !window.jQuery || !window.jQuery.fn || typeof window.jQuery.fn.rateYo !== 'function') {
      return;
    }

    try {
      window.jQuery(element).rateYo('option', 'rating', 0);
    } catch (error) {
      // The picker may not have been initialized yet.
    }
  }

  function fetchReviewData(url) {
    if (!url) {
      return Promise.resolve([]);
    }

    if (!dataCache.has(url)) {
      dataCache.set(
        url,
        fetch(url, { cache: 'no-store' })
          .then((response) => {
            if (!response.ok) {
              throw new Error(`Unable to load reviews (${response.status})`);
            }

            return response.text();
          })
          .then((text) => {
            const parsed = JSON.parse(text || '[]');
            return Array.isArray(parsed) ? parsed : [];
          })
      );
    }

    return dataCache.get(url);
  }

  function findEntryForSku(entries, sku) {
    const normalizedSku = normalizeSku(sku);

    if (!normalizedSku || !Array.isArray(entries)) {
      return null;
    }

    return entries.find((entry) => {
      if (normalizeSku(entry && entry.sku) === normalizedSku) {
        return true;
      }

      return Array.isArray(entry && entry.skus) && entry.skus.some((entrySku) => normalizeSku(entrySku) === normalizedSku);
    }) || null;
  }

  function localizedDate(review, language) {
    return language === 'fr' ? review.date_fr || review.date_en || '' : review.date_en || review.date_fr || '';
  }

  class ProductReviewBase extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      this.i18n = getI18n(this);
      this.variants = readJsonScript(this, '[data-product-review-variants]', []);
      this.language = this.dataset.language === 'fr' ? 'fr' : 'en';
      this.currentVariant = this.getInitialVariant();
      this.currentSku = this.currentVariant.sku || this.dataset.currentSku || '';
      this.currentVariantId = this.currentVariant.id || this.dataset.currentVariantId || '';
      this.bindVariantChanges();
      this.loadReviewData();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.variantUnsubscriber?.();
    }

    getInitialVariant() {
      const currentVariantId = String(this.dataset.currentVariantId || '');
      const variant = this.variants.find((item) => String(item.id) === currentVariantId);

      return variant || {
        id: this.dataset.currentVariantId || '',
        sku: this.dataset.currentSku || ''
      };
    }

    bindVariantChanges() {
      this.handleVariantChange = (event) => {
        const variant = event.detail && event.detail.variant;

        if (variant) {
          this.setVariant(variant);
        }

        window.setTimeout(() => this.refreshVariantFromDom(), 0);
      };

      document.addEventListener('variant:changed', this.handleVariantChange, { signal: this.abortController.signal });

      if (
        window.FoxTheme &&
        window.FoxTheme.pubsub &&
        typeof window.FoxTheme.pubsub.subscribe === 'function' &&
        window.FoxTheme.pubsub.PUB_SUB_EVENTS &&
        window.FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange
      ) {
        this.variantUnsubscriber = window.FoxTheme.pubsub.subscribe(
          window.FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,
          (event) => {
            const variant = event && event.data && event.data.variant;

            if (variant) {
              this.setVariant(variant);
            }
          }
        );
      }
    }

    refreshVariantFromDom() {
      const selectedVariant = document.querySelector('product-info variant-selects [data-selected-variant]');

      if (!selectedVariant) {
        return;
      }

      try {
        this.setVariant(JSON.parse(selectedVariant.textContent || '{}'));
      } catch (error) {
        // Ignore malformed variant snapshots from the theme runtime.
      }
    }

    setVariant(variant) {
      if (!variant) {
        return;
      }

      const matchingVariant = this.variants.find((item) => String(item.id) === String(variant.id));

      if (this.variants.length && !matchingVariant) {
        return;
      }

      const nextVariant = Object.assign({}, matchingVariant || {}, variant);
      const nextSku = nextVariant.sku || '';

      if (!nextSku && !nextVariant.id) {
        return;
      }

      this.currentVariant = nextVariant;
      this.currentSku = nextSku;
      this.currentVariantId = nextVariant.id == null ? '' : String(nextVariant.id);
      this.renderCurrentEntry();
    }

    loadReviewData() {
      this.setLoadingState();

      fetchReviewData(this.dataset.reviewsUrl)
        .then((entries) => {
          this.reviewEntries = entries;
          this.renderCurrentEntry();
        })
        .catch(() => {
          this.reviewEntries = [];
          this.renderErrorState();
        });
    }

    get currentEntry() {
      return findEntryForSku(this.reviewEntries || [], this.currentSku);
    }

    setLoadingState() {}

    renderCurrentEntry() {}

    renderErrorState() {}
  }

  class ProductReviewSummary extends ProductReviewBase {
    connectedCallback() {
      this.starsElement = this.querySelector('[data-review-summary-stars]');
      this.countElement = this.querySelector('[data-review-summary-count]');
      this.averageElement = this.querySelector('[data-review-summary-average]');
      this.triggerElement = this.querySelector('[data-review-trigger]');
      this.loginElement = this.querySelector('[data-review-login]');

      this.triggerElement?.addEventListener('click', () => {
        document.dispatchEvent(new CustomEvent('product-reviews:open'));
      });

      this.loginElement?.addEventListener('click', (event) => {
        event.preventDefault();
        window.location.href = this.dataset.loginUrl || this.loginElement.href;
      });

      super.connectedCallback();
    }

    setLoadingState() {
      setText(this.countElement, this.i18n.loading);
      setText(this.averageElement, '');
      renderStars(this.starsElement, 0, this.i18n);
    }

    renderErrorState() {
      setText(this.countElement, this.i18n.no_reviews_short);
      setText(this.averageElement, '');
      renderStars(this.starsElement, 0, this.i18n);
    }

    renderCurrentEntry() {
      if (!this.reviewEntries) {
        return;
      }

      const entry = this.currentEntry;
      const count = Number(entry && entry.reviews_count) || 0;
      const rating = Number(entry && entry.overall_rating) || 0;

      renderStars(this.starsElement, rating, this.i18n);
      setText(this.countElement, countText(count, this.i18n));
      setText(this.averageElement, count > 0 ? `${formatRating(rating)} / 5` : '');
    }
  }

  class ProductReviews extends ProductReviewBase {
    connectedCallback() {
      this.visibleCount = initialVisibleReviews;
      this.statusElement = this.querySelector('[data-review-status]');
      this.summaryElement = this.querySelector('[data-review-summary]');
      this.listElement = this.querySelector('[data-review-list]');
      this.loadMoreButton = this.querySelector('[data-review-load-more]');
      this.modalElement = this.querySelector('[data-review-modal]');
      this.formElement = this.querySelector('[data-review-form]');
      this.messageElement = this.querySelector('[data-review-message]');
      this.submitButton = this.querySelector('[data-review-submit]');
      this.ratingPickerElement = this.querySelector('[data-review-rating-picker]');
      this.ratingInputElement = this.querySelector('[data-review-rating-input]');
      this.skuFields = this.querySelectorAll('[data-review-sku-field]');
      this.variantFields = this.querySelectorAll('[data-review-variant-field]');

      this.summaryRefs = {
        stars: this.querySelector('[data-review-overall-stars]'),
        overall: this.querySelector('[data-review-overall]'),
        count: this.querySelector('[data-review-count]'),
        recommended: this.querySelector('[data-review-recommended]')
      };

      this.querySelectorAll('[data-review-login]').forEach((element) => {
        element.addEventListener('click', (event) => {
          event.preventDefault();
          this.redirectToLogin();
        });
      });

      this.querySelectorAll('[data-review-trigger]').forEach((element) => {
        element.addEventListener('click', () => this.prepareForm());
      });

      this.loadMoreButton?.addEventListener('click', () => {
        this.visibleCount += moreReviewsStep;
        this.renderReviewList();
      });

      this.formElement?.addEventListener('submit', (event) => this.submitReview(event));

      super.connectedCallback();
      initializeRatingPicker(this.ratingPickerElement, this.ratingInputElement);

      document.addEventListener('product-reviews:open', () => this.openForm(), { signal: this.abortController.signal });

      if (new URLSearchParams(window.location.search).has('show_review')) {
        window.setTimeout(() => this.openForm(), 300);
      }
    }

    setLoadingState() {
      setHidden(this.statusElement, false);
      setText(this.statusElement, this.i18n.loading);
      setHidden(this.summaryElement, true);
      setHidden(this.listElement, true);
      setHidden(this.loadMoreButton, true);
    }

    renderErrorState() {
      setHidden(this.statusElement, false);
      setText(this.statusElement, this.i18n.generic_error);
      setHidden(this.summaryElement, true);
      setHidden(this.listElement, true);
      setHidden(this.loadMoreButton, true);
    }

    renderCurrentEntry() {
      if (!this.reviewEntries) {
        return;
      }

      this.updateHiddenVariantInputs();
      this.visibleCount = initialVisibleReviews;

      const entry = this.currentEntry;
      const count = Number(entry && entry.reviews_count) || 0;
      const rating = Number(entry && entry.overall_rating) || 0;

      if (!entry || count === 0) {
        setHidden(this.statusElement, false);
        setText(this.statusElement, this.i18n.empty);
        setHidden(this.summaryElement, true);
        setHidden(this.listElement, true);
        setHidden(this.loadMoreButton, true);
        this.listElement?.replaceChildren();
        return;
      }

      setHidden(this.statusElement, true);
      setHidden(this.summaryElement, false);
      setHidden(this.listElement, false);
      renderStars(this.summaryRefs.stars, rating, this.i18n);
      setText(this.summaryRefs.overall, `${formatRating(rating)} / 5`);
      setText(this.summaryRefs.count, countText(count, this.i18n));
      setText(this.summaryRefs.recommended, `${Number(entry.recommended) || 0}% ${this.i18n.recommended}`);

      this.renderReviewList();
    }

    renderReviewList() {
      const entry = this.currentEntry;
      const reviews = Array.isArray(entry && entry.reviews) ? entry.reviews : [];
      const visibleReviews = reviews.slice(0, this.visibleCount);

      this.listElement?.replaceChildren(...visibleReviews.map((review) => this.createReviewElement(review)));
      setHidden(this.loadMoreButton, reviews.length <= this.visibleCount);
    }

    createReviewElement(review) {
      const article = createElement('article', 'product-reviews__review');
      const aside = createElement('div', 'product-reviews__review-aside');
      const main = createElement('div', 'product-reviews__review-main');
      const top = createElement('div', 'product-reviews__review-top');
      const stars = createElement('div', 'product-review-stars');
      const date = createElement('div', 'product-reviews__review-meta', localizedDate(review, this.language));
      const title = createElement('div', 'product-reviews__review-title', review.review_title || '');
      const text = createElement('p', 'product-reviews__review-text', review.review_text || '');

      aside.append(createElement('div', 'product-reviews__review-author', review.name || ''));

      if (Number(review.verified_purchase) === 1) {
        aside.append(createElement('div', 'product-reviews__review-meta', this.i18n.verified_purchase));
      }

      if (review.location) {
        aside.append(createElement('div', 'product-reviews__review-meta', `${this.i18n.location}: ${review.location}`));
      }

      renderStars(stars, review.overall_rating, this.i18n);
      top.append(stars, date);

      main.append(top, title, text);

      main.append(
        createElement(
          'div',
          'product-reviews__review-recommendation',
          Number(review.recommended) === 1 ? this.i18n.yes_recommendation : this.i18n.no_recommendation
        )
      );

      article.append(aside, main);
      return article;
    }

    openForm() {
      if (!this.isLoggedIn()) {
        this.redirectToLogin();
        return;
      }

      this.prepareForm();

      if (this.modalElement && typeof this.modalElement.show === 'function') {
        this.modalElement.show(document.activeElement);
      }
    }

    prepareForm() {
      this.updateHiddenVariantInputs();
      initializeRatingPicker(this.ratingPickerElement, this.ratingInputElement);
      this.showMessage('', '');
    }

    isLoggedIn() {
      return this.dataset.customerLoggedIn === 'true';
    }

    redirectToLogin() {
      window.location.href = this.dataset.loginUrl || '/account/login';
    }

    updateHiddenVariantInputs() {
      this.skuFields?.forEach((field) => {
        field.value = this.currentSku || '';
      });
      this.variantFields?.forEach((field) => {
        field.value = this.currentVariantId || '';
      });
    }

    showMessage(type, message) {
      if (!this.messageElement) {
        return;
      }

      this.messageElement.classList.remove('product-reviews__message--success', 'product-reviews__message--error');

      if (!message) {
        this.messageElement.hidden = true;
        this.messageElement.textContent = '';
        return;
      }

      this.messageElement.hidden = false;
      this.messageElement.textContent = message;
      this.messageElement.classList.add(`product-reviews__message--${type}`);
    }

    setSubmitting(isSubmitting) {
      if (!this.submitButton) {
        return;
      }

      this.submitButton.disabled = isSubmitting;
      this.submitButton.textContent = isSubmitting ? this.i18n.submitting : this.submitButton.dataset.defaultText;
    }

    submitReview(event) {
      event.preventDefault();

      if (!this.isLoggedIn()) {
        this.redirectToLogin();
        return;
      }

      if (!this.formElement.reportValidity()) {
        this.showMessage('error', this.i18n.validation_error);
        return;
      }

      this.updateHiddenVariantInputs();
      this.setSubmitting(true);
      this.showMessage('', '');

      const formData = new FormData(this.formElement);
      const payload = {
        action: 'add-review',
        sku: this.currentSku || formData.get('sku') || '',
        variant_id: String(this.currentVariantId || formData.get('variant_id') || ''),
        name: formData.get('name') || '',
        email: formData.get('email') || '',
        review_title: formData.get('review_title') || '',
        review_text: formData.get('review_text') || '',
        overall_rating: Number(formData.get('overall_rating') || 0),
        recommended: formData.get('recommended') === '1' ? 1 : 0,
        location: formData.get('location') || '',
        v_p: this.dataset.verifiedPurchase === 'true' ? 1 : 0,
        language: this.language
      };

      if (!Number.isInteger(payload.overall_rating) || payload.overall_rating < 1 || payload.overall_rating > 5) {
        this.setSubmitting(false);
        this.showMessage('error', this.i18n.validation_error);
        return;
      }

      fetch(this.dataset.apiUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      })
        .then((response) =>
          response.json().catch(() => ({})).then((data) => {
            if (!response.ok || data.success === false) {
              const errorMessage = Array.isArray(data.error_message)
                ? data.error_message.join(' ')
                : data.error_message || data.message || this.i18n.generic_error;
              throw new Error(errorMessage);
            }

            return data;
          })
        )
        .then(() => {
          this.formElement.reset();
          this.updateHiddenVariantInputs();
          resetRatingPicker(this.ratingPickerElement, this.ratingInputElement);
          this.showMessage('success', this.i18n.success);
        })
        .catch((error) => {
          this.showMessage('error', error.message || this.i18n.generic_error);
        })
        .finally(() => {
          this.setSubmitting(false);
        });
    }
  }

  if (!customElements.get('product-review-summary')) {
    customElements.define('product-review-summary', ProductReviewSummary);
  }

  if (!customElements.get('product-reviews')) {
    customElements.define('product-reviews', ProductReviews);
  }
})();
